import { Location } from '@cobliteam/common-types';
import { ActivationTasksTypes, type Category, type Task } from '../ActivationTasksCommon';

const BasicSettingsSteps = {
  i18nKey: 'basic_settings',
  steps: [
    {
      i18nKey: 'schedule_installations',
      url: Location.ORDERS,
      step: ActivationTasksTypes.SCHEDULE_INSTALLATIONS,
      permissions: ['create-update-delete:crm'],
      id: '7250c510-4633-4edb-891f-2009137aa4a4',
    },
    {
      i18nKey: 'invite_users',
      url: Location.CONFIG_USERS,
      step: ActivationTasksTypes.INVITE_USERS,
      permissions: ['create-update-delete:users-and-invites'],
      id: 'a10466eb-f31d-4cab-a8d6-3c34830ffb5d',
    },
    {
      i18nKey: 'create_vehicles',
      url: Location.VEHICLES,
      step: ActivationTasksTypes.CREATE_VEHICLES,
      permissions: ['create-update-delete:vehicle'],
      id: '3ba551a7-75f7-426e-8f22-2e8e597bb04d',
    },
    {
      i18nKey: 'create_drivers',
      url: Location.DRIVER_MANAGEMENT,
      step: ActivationTasksTypes.CREATE_DRIVERS,
      permissions: ['create-update-delete:driver'],
      id: '94ac8eff-d2c5-4818-b801-bf1bcd35f1e4',
    },
    {
      i18nKey: 'organize_groups',
      url: Location.VEHICLES_GROUPS,
      step: ActivationTasksTypes.ORGANIZE_GROUPS,
      permissions: ['create-update-delete:vehicle'],
      id: '3e37790a-d939-476a-beaf-0bdfd5cfbe5f',
    },
  ],
};

const AdvancedSettingsSteps = {
  i18nKey: 'advanced_settings',
  steps: [
    {
      i18nKey: 'configure_alerts',
      url: Location.ALERTS,
      step: ActivationTasksTypes.CONFIGURE_ALERTS,
      permissions: ['config-and-view:custom-alerts'],
      id: 'cede7793-e85b-4db9-bde5-bcd50e4b9aeb',
    },
    {
      i18nKey: 'create_geofences',
      url: Location.GEOFENCES,
      step: ActivationTasksTypes.CREATE_GEOFENCES,
      permissions: ['create-update-delete:places-of-interest'],
      id: '7152c1d7-0047-4ea4-ad95-58a471a33bb8',
    },
    {
      i18nKey: 'create_checklists',
      url: Location.CHECKLIST,
      step: ActivationTasksTypes.CREATE_CHECKLISTS,
      permissions: ['full-control:checklist'],
      id: 'fa8a5faf-178c-415e-9d8c-d59eef19c637',
    },
  ],
};

export const ActivationTasksList = [BasicSettingsSteps, AdvancedSettingsSteps];

export const getOnboardingTaskConfiguration = (): Category[] => {
  return ActivationTasksList.map((category) => {
    const tasks: Task[] = category.steps.map((step) => {
      return {
        i18nKey: step.i18nKey,
        url: step.url,
        name: step.step,
        permissions: step.permissions,
        id: step.id,
      } as Task;
    });

    return {
      i18nKey: category.i18nKey,
      tasks,
    };
  });
};
